// src/views/BackOfficeDashboard.js
import React from 'react';
import { Card, CardBody, CardTitle, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';

const BackOfficeDashboard = () => {
  return (
    <div>
      <Card className="mb-4">
        <CardBody>
          <CardTitle tag="h4" className="mb-4">
            <i className="bi bi-speedometer2 me-2"></i>
            Back Office Dashboard
          </CardTitle>
          <p className="lead">Welcome, Back Office User! Access administrative tools.</p>
        </CardBody>
      </Card>

      <Row>
        {/* Create Tutoring Agent Card */}
        <Col md="6" lg="4" className="mb-4">
          <Card className="h-100 shadow-sm">
            <CardBody className="d-flex flex-column">
              <div className="mb-3">
                <i className="bi bi-person-plus-fill" style={{ fontSize: '2.5rem', color: '#0d6efd' }}></i>
              </div>
              <CardTitle tag="h5" className="mb-3">Create Tutoring Agent</CardTitle>
              <p className="text-muted mb-3">
                Register new tutoring agents (individual tutors or tutoring organizations).
              </p>
              <Link to="/backoffice/create-tutoring-agent" className="btn btn-primary mt-auto">
                <i className="bi bi-plus-circle me-2"></i>
                Create Agent
              </Link>
            </CardBody>
          </Card>
        </Col>

        {/* Placeholder for future features */}
        <Col md="6" lg="4" className="mb-4">
          <Card className="h-100 shadow-sm">
            <CardBody className="d-flex flex-column">
              <div className="mb-3">
                <i className="bi bi-people-fill" style={{ fontSize: '2.5rem', color: '#6c757d' }}></i>
              </div>
              <CardTitle tag="h5" className="mb-3">Manage Users</CardTitle>
              <p className="text-muted mb-3">
                View and manage all system users.
              </p>
              <Button color="secondary" disabled className="mt-auto">
                Coming Soon
              </Button>
            </CardBody>
          </Card>
        </Col>

        <Col md="6" lg="4" className="mb-4">
          <Card className="h-100 shadow-sm">
            <CardBody className="d-flex flex-column">
              <div className="mb-3">
                <i className="bi bi-gear-fill" style={{ fontSize: '2.5rem', color: '#6c757d' }}></i>
              </div>
              <CardTitle tag="h5" className="mb-3">System Settings</CardTitle>
              <p className="text-muted mb-3">
                Configure system-wide settings and preferences.
              </p>
              <Button color="secondary" disabled className="mt-auto">
                Coming Soon
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default BackOfficeDashboard;